import { useSearchParams } from 'react-router-dom';

export const useSignupDocVariantsFromUrl = () => {
  const [searchParams] = useSearchParams();
  const tosVariant = searchParams.get('tosVariant') || 'tos.md';
  const baaVariant = searchParams.get('baaVariant') || 'baa.md';
  const aaVariant = searchParams.get('aaVariant') || 'aa.md';
  return { tosVariant, baaVariant, aaVariant };
};
